/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { TopBar } from "~/components";
import { useBillingPeriod } from "~/services/customers";

const TEXT_CTA = "This is previous month view.";
const TEXT_BUTTON = "Switch to the Current Month";

export function BillingPeriodBar() {
  const { activateCurrentBillingPeriod, isPreviousBillingPeriod } =
    useBillingPeriod();

  if (isPreviousBillingPeriod) {
    return (
      <TopBar
        buttonContent={TEXT_BUTTON}
        onClose={activateCurrentBillingPeriod}
      >
        {TEXT_CTA}
      </TopBar>
    );
  }

  return null;
}
